<template>
    <div class="bg-light-danger text-danger rounded p-8 d-flex flex-row align-items-center gap-5">
        <div>
            <i class="fas fa-exclamation-triangle" style="font-size:2em; color:inherit;"/>
        </div>
        <div>
            <div class="font-size-lg font-weight-bold">
                {{ error.title }}
            </div>
            {{ error.message }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: Object,
            required: true,
            default() {
                return {
                    title: 'TITLE',
                    message: 'MESSAGE'
                };
            }
        }
    }
}
</script>
